window.styleInview = {

	local : null,
	targets : [],
	observer : null,

	onInit( elem ){

		console.log('styleInview - onInit');

		//===
		this.local = elem ? elem : document.querySelector('.c-local');
		this.inview  = document.querySelectorAll('.js-iv');
		this.targets = [ ...this.inview ];

		//===
		if (this.targets.length) {
			this.options = {
				threshold: 0
			};
			this.observer = new IntersectionObserver(this.listerner, this.options);
			this.targets.forEach((e, i) => {
				this.observer.observe( e );
			});
		}

	},

	onReInit(){
		this.onDestroy();
		this.onInit();
	},

	listerner(changes) {
		changes.forEach((e, i) => {
			const el = e.target;
			const isIntersecting = e.isIntersecting;
			if ( isIntersecting ) {
				el.dataset.shown = 1;
				el.dataset.visible = 1;
			} else {
				el.dataset.visible = 0;
			}
		});
	},

	onDestroy(){
		if( this.observer ) {
			this.targets.forEach((e, i) => {
				this.observer.disconnect(e);
			})
			this.targets  = [];
			this.observer = null;
		}
	}

}
